import { ParameterGroup } from 'communication/types/strategyParams/StrategyParametersElement';
import { WidgetStreamState } from 'widgets/store/stream/WidgetStreamState';

export type OrderSelectionType = 'single' | 'multiple' | undefined;

export interface StrategyParametersStreamKeyState {
    single?: string;
    multiple?: string;
}

export interface StrategyParametersStreamDataState {
    orderSelection: OrderSelectionType;
    paramGroups: ParameterGroup[];
    streamKeys: StrategyParametersStreamKeyState;
}

export type StrategyParametersStreamState =
    WidgetStreamState<StrategyParametersStreamDataState>;

export const initialStrategyParametersStreamDataState: StrategyParametersStreamDataState =
    {
        orderSelection: undefined,
        paramGroups: [{}],
        streamKeys: {},
    };

export const initialStrategyParametersStreamState: StrategyParametersStreamState =
    {
        data: initialStrategyParametersStreamDataState,
        messages: [],
    };
